import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BRAND } from "../lib/brand";
import { resetPassword, formatApiErrorDetail } from "../lib/auth";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return toast.error("Password minimal 8 karakter");
    if (pwd !== pwd2) return toast.error("Password tidak sama");
    setLoading(true);
    try {
      await resetPassword(token, pwd);
      setDone(true);
      setTimeout(() => navigate("/admin"), 2500);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Gagal reset password");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center p-5">
        <div className="max-w-md w-full bg-white rounded-3xl border border-soft p-8 text-center">
          <h2 className="font-display font-bold text-xl text-ink">Link tidak valid</h2>
          <p className="mt-3 text-sm text-ink-muted">Token reset password tidak ditemukan di URL.</p>
          <Link to="/admin/forgot-password" className="inline-block mt-6">
            <Button className="rounded-full bg-brand-red hover:bg-[#A60D25] text-white">Minta link baru</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-5" data-testid="reset-password-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-soft p-8 soft-shadow">
        <div className="flex items-center gap-2 mb-6">
          <img src={BRAND.logoIcon} alt="AsiaCommerce" className="h-10 w-10 object-contain" />
          <div>
            <div className="font-display font-extrabold text-lg text-ink">Reset Password</div>
            <div className="text-xs text-ink-muted">AsiaCommerce Hub</div>
          </div>
        </div>

        {done ? (
          <div className="text-center py-6" data-testid="reset-success">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="font-display font-bold text-xl text-ink">Password berhasil diubah</h2>
            <p className="mt-3 text-sm text-ink-muted">Mengarahkan Anda ke halaman login…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div>
              <Label className="text-sm font-semibold text-ink">Password baru</Label>
              <Input type="password" required minLength={8} value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-pwd" className="h-12 rounded-xl border-soft mt-1.5" placeholder="Min. 8 karakter" />
            </div>
            <div>
              <Label className="text-sm font-semibold text-ink">Konfirmasi password</Label>
              <Input type="password" required minLength={8} value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="reset-pwd2" className="h-12 rounded-xl border-soft mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-full bg-brand-red hover:bg-[#A60D25] text-white font-semibold" data-testid="reset-submit-btn">
              {loading ? "Menyimpan…" : "Simpan Password Baru"}
            </Button>
            <Link to="/admin" className="block text-center text-xs text-ink-muted hover:text-brand-red"><ArrowLeft className="w-3 h-3 inline mr-1" /> Batalkan</Link>
          </form>
        )}
      </div>
    </div>
  );
}
